import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchActionsService } from 'src/app/core/services/job-match-actions.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { SharedService } from 'src/app/core/services/shared.service';
declare var _: any;

@Component({
    selector: 'app-job-match-profile-on-conference',
    templateUrl: './job-match-profile-on-conference.component.html',
    styleUrls: ['./job-match-profile-on-conference.component.css']
})
export class JobMatchProfileOnConferenceComponent implements OnChanges, OnDestroy {
    @Input() jobMatchId: any;
    @Input() jobId: any;
    @Input() candidateId: any;
    @Input() scheduleId: any;
    @Input() workflowStep: any;
    @Input() feedbackUserIdsList: any;
    @Input() context: any;
    @Input() displayFeedback: any;
    @Input() displaySchedules: any;
    @Input() displayCommunication: any;
    @Input() displayPhoneScreenCompletedFeedbacks: any;
    @Input() usersToEditFeedback: any;
    @Input() feedbackReadOnly: any;
    @Input() externalMeetingCallId: any;
    @Input() sourceScreen: any;
    @Input() formalizeActivityPayload: any;
    @Output() saveCallback = new EventEmitter<any>();
    @Output() completeFeedbackCallback = new EventEmitter<any>();

    isLoading: boolean;
    tabs: any[];
    validTabs: any[];
    steps: any[];
    companyId: any;
    isCorporateFlag: boolean;
    isCandidateContactDetailsMissing = false;
    enabledWorkflowSteps: any;
    jobMatchInfo: any;
    jobLocation: string;
    sectionalReport: boolean;
    taUrl: string;
    vaUrl: string;
    feedbackType: string;
    itemType: string;
    phoneScreenFeedbackUrl: string;
    outreachReportUrl: string;
    interviewFeedbackUrl: string;
    recruiterScreeningFeedbackUrl: string;
    isRecruiterScreeningFeedbackAvailable: boolean;
    isPhoneScreenFeedbackAvailable: boolean;
    isInterviewFeedbackAvailable: boolean;
    outreachFeedbackFileName: string;
    generalFileName: string;
    taFileName: string;
    vaFileName: string;
    recruiterScreeningFileName: string;
    phoneScreeningFileName: string;
    interviewFeedbackFileName: string;

    private refreshBookletSubscription: Subscription;

    constructor(
        private jobService: JobService,
        private jobMatchService: JobMatchService,
        private companyService: CompanyService,
        private meetingService: MeetingService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private sharedService: SharedService,
        private jobMatchActionsService: JobMatchActionsService,
        private authService: AuthService
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (this._areElementsResolved(changes)) {
            this._init();
        }
    }

    _areElementsResolved(changes: SimpleChanges): boolean {
        const hasUsersListChanged = changes.usersToEditFeedback !== undefined
            && changes.usersToEditFeedback.currentValue !== changes.usersToEditFeedback.previousValue
            && changes.candidateId === undefined;
        return !hasUsersListChanged;
    }

    _init() {
        console.warn('Job match profile on conference reloading ');
        this.isLoading = true;
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.authService.getUserDetails().company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this.isCandidateContactDetailsMissing = false;
        this._getData();
        if (this.externalMeetingCallId && !this.refreshBookletSubscription) {
            this._setMeetingListener();
        }
    }

    _setMeetingListener() {
        this.refreshBookletSubscription = this.meetingService.refreshCandidateBooklet.subscribe(() => {
            this._init();
        });
    }

    _getData() {
        this.isLoading = true;
        this.getEnabledWorkflowSteps(() => {
            this.getCandidateJobMatchCardInfo(() => {
                if (this.workflowStep === 'rs') {
                    this._checkAvailableFeedbackReports(() => {
                        this._initFileNames();
                        this._loadTabs();
                        this.isLoading = false;
                    });
                } else {
                    this.getMoveToInterviewStepPossibility(() => {
                        this._checkAvailableFeedbackReports(() => {
                            this._initFileNames();
                            this._loadTabs();
                            this.isLoading = false;
                        });
                    });
                }
            });
        });
    }

    getEnabledWorkflowSteps(successCallback) {
        this.jobService.getEnabledWorkflowSteps(this.jobId, (data) => {
            this.enabledWorkflowSteps = data;
            this.steps = [];
            this.steps.push('Outreach');
            _.forEach(this.enabledWorkflowSteps, (step) => {
                this.steps.push(step);
            });
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    getCandidateJobMatchCardInfo(successCallback) {
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.jobMatchInfo = data;
            this.jobMatchInfo.name = data.firstName + ' ' + data.lastName;
            this.jobLocation = '';
            if (this.jobMatchInfo.jobLocation !== null) {
                this.jobLocation = this.jobService.getParsedJobLocationText(this.jobMatchInfo.jobLocation, false);
            }
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            this.jobMatchInfo.candidateInformationList = this._setCandidateEmailSubjectAndBody(this.jobMatchInfo).candidateInfoInEmailBody;
            this._checkIfContactDetailsMissing();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        }, undefined);
    }

    _setCandidateEmailSubjectAndBody(candidate) {
        const candidateInformation: any = {};
        candidateInformation.subject = `Candidate Information: ${candidate.firstName ? candidate.firstName : ''} ${candidate.lastName ? candidate.lastName : ''} – ${candidate.jobMatchTitle} (Req #${candidate.jobMatchRequisitionNum})`;
        candidateInformation.body = '';
        candidate.candidateAdditionalDetails.preferredWorkLocations = candidate.workLocations;
        candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetails);
        return candidateInformation;
    }

    getMoveToInterviewStepPossibility(successCallback) {
        if (this.scheduleId) {
            this.meetingService.getMoveToInterviewStepPossibility(this.scheduleId, (data) => {
                this.jobMatchInfo.interviewNextStep = data.interviewNextStep;
                this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = data.canMoveCandidateToInterviewAfterCurrentFeedback;
                if (successCallback) {
                    successCallback();
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        } else {
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            successCallback();
        }
    }

    // Recruiter Screening's next step isn't always Interview (could be Tech Assessment,
    // Value Assessment, etc.), so it reads the real next step off availableActions'
    // MOVE_FORWARD action instead of the interview-only getMoveToInterviewStepPossibility check.
    _getMoveForwardAction() {
        if (!this.jobMatchInfo || !this.jobMatchInfo.availableActions) {
            return null;
        }
        return this.jobMatchInfo.availableActions.find(action => action.actionType && action.actionType.includes('MOVE_FORWARD')) || null;
    }

    // Builds the "next step" tab shown alongside the current feedback tab (e.g. Recruiter
    // Screening, Phone Screen), using whatever the real next step is. It's actionable
    // (renders move-job-match-step) once the API reports the move is allowed, and shows
    // a disabled placeholder message until then.
    _getNextStepPreviewTab(currentStepLabel) {
        const moveForwardAction = this._getMoveForwardAction();
        if (!moveForwardAction) {
            return null;
        }
        const nextStepName = moveForwardAction.action.replace(/^Move to /, '');
        const message = moveForwardAction.message || `The ${currentStepLabel} feedback(s) of the candidate have to be completed and the candidate has to be moved to the ${nextStepName} step before ${nextStepName} can be scheduled.`;
        return { name: nextStepName, step: nextStepName, feedbackType: nextStepName.replace(/\s+/g, ''), isActive: true, displayFeedback: false, isMoveForwardTab: true, actionLabel: moveForwardAction.action, disabled: !moveForwardAction.allowed, isNextStepPreview: true, message: message };
    }

    _checkAvailableFeedbackReports(successCallback) {
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
            const feedbackReports = data.feedbackReportsAvailability;
            this.isRecruiterScreeningFeedbackAvailable = feedbackReports['recruiterScreeningFeedbackReport'];
            this.isPhoneScreenFeedbackAvailable = feedbackReports['phoneScreenFeedbackReport'];
            this.isInterviewFeedbackAvailable = feedbackReports['interviewFeedbackReport'];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _initFileNames() {
        this.outreachFeedbackFileName = this.generalFileName + '-outrachFeedback' + '.pdf';
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.taFileName = this.generalFileName + '-' + this.jobMatchInfo.techAssessmentName + '.pdf';
        this.vaFileName = this.generalFileName + '-' + this.jobMatchInfo.valueAssessmentName + '.pdf';
        this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    }

    _loadTabs() {
        this.tabs = [];
        this.validTabs = [];
        this._loadWorkflowSteps();
        this._loadValidTabs();
        this._setActiveTab();
    }

    _loadWorkflowSteps() {
        this.sectionalReport = false;
        if (this.jobMatchInfo.isSharedRequisition && !this.isCorporateFlag) {
            this.sectionalReport = true;
        }
        if (!_.isNull(this.jobMatchInfo.techAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.techAssessmentScore) && this.jobMatchInfo.techAssessmentScore.toString() != '') {
            this.taUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.techAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.techAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: 'Tech Assessment', step: 'Tech Assessment', fileName: this.taFileName, url: this.taUrl, isLoading: false });
        }

        if (!_.isNull(this.jobMatchInfo.valueAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.valueAssessmentScore) && this.jobMatchInfo.valueAssessmentScore.toString() != '') {
            this.vaUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.valueAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.valueAssessmentInvitationId + '&sectional=' + this.sectionalReport;
            this.tabs.push({ name: 'Value Assessment', step: 'Value Assessment', fileName: this.vaFileName, url: this.vaUrl, isLoading: false });
        }

        if (this.workflowStep === 'rs') {
            this.tabs.push({ name: 'Feedback', step: 'Recruiter Screening', feedbackType: 'RecruiterScreening', isActive: true });
            const nextStepPreviewTab = this._getNextStepPreviewTab('Recruiter Screening');
            if (nextStepPreviewTab) {
                this.tabs.push(nextStepPreviewTab);
            }
        }

        if (this.workflowStep === 'ps' && this.displayFeedback) {
            this.feedbackType = 'Phone Screen';
            this.itemType = 'phoneScreen';
            if (this.displaySchedules) {
                if (this.jobMatchInfo.currentStep == 'Interview') {
                    this.tabs.push({ name: 'Phone Screen', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: false, displayFeedback: true });
                    this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: false });
                } else {
                    this.tabs.push({ name: 'Phone Screen', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: true, displayFeedback: true });
                }

                if (this.jobMatchInfo.interviewNextStep) {
                    this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: false, disabled: true, message: 'The Phone screen feedback(s) of the candidate have to be completed and the candidate has to be moved to the interview step before an interview can be scheduled.' });
                }
            } else {
                if (this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = 'api/jobmatch/getphonescreenfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Completed Feedback', step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
                }
                this.tabs.push({ name: 'Feedback', step: 'Phone Screen', feedbackType: 'PhoneScreen', isActive: true });
            }
        }

        if (this.workflowStep === 'in' && this.displayFeedback) {
            this.feedbackType = 'Interview';
            this.itemType = 'interview';
            if (this.jobMatchInfo.outreachReport) {
                this.outreachReportUrl = 'api/jobmatch/outreachFeedbackReport/' + this.jobMatchId + '?companyId=' + this.companyId;
                this.tabs.push({ name: 'Outreach', step: 'Outreach', fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, isLoading: false });
            }
            if (this.displaySchedules) {
                this.tabs.push({ name: 'Interview', step: 'Interview', feedbackType: 'Interview', isActive: true, displayFeedback: true, disabled: false });
                if (this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = 'api/jobmatch/getphonescreenfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Phone Screen(s)', step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
                }
                if (this.isRecruiterScreeningFeedbackAvailable) {
                    this.recruiterScreeningFeedbackUrl = 'api/jobmatch/getscreeningfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Recruiter Screening', step: 'Recruiter Screening', fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, isLoading: false });
                }
            } else {
                if (this.displayPhoneScreenCompletedFeedbacks && this.isPhoneScreenFeedbackAvailable) {
                    this.phoneScreenFeedbackUrl = 'api/jobmatch/getphonescreenfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Completed Feedback', step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false, isActive: true });
                } else if (this.isInterviewFeedbackAvailable) {
                    this.interviewFeedbackUrl = 'api/jobmatch/getinterviewfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Completed Feedback', step: 'Interview', fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
                }
                if (!this.displayPhoneScreenCompletedFeedbacks) {
                    this.tabs.push({ name: 'Feedback', step: 'Interview', feedbackType: 'Interview', isActive: true });
                }
            }
        }
    }

    _loadValidTabs() {
        let isProfileActive = !this.displayFeedback;
        if (this.workflowStep == 'rs') {
            isProfileActive = false;
        }
        const candidateProfileTab = { name: 'Profile', step: 'Profile', isActive: isProfileActive };
        this.validTabs.push(candidateProfileTab);
        this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
        this.validTabs.push({ name: 'Compare', step: 'Compare' });

        this.steps.forEach((step) => {
            this.tabs.forEach((tab) => {
                if (tab.step == step) {
                    this.validTabs.push(tab);
                }
            });
        });
        if (this.displayCommunication) {
            this.validTabs.push({ name: 'Communication', step: 'Communication' });
        }
    }

    _setActiveTab() {
        const activeTab = this.validTabs.find(tab => tab.isActive == true);
        this.validTabs.forEach(tab => tab.isActive = (tab === activeTab));
    }

    selectTab(tab) {
        this.validTabs.forEach(t => t.isActive = (t === tab));
    }

    // Unlike Phone Screen/Interview (whose schedules-on-profile sub-component reloads
    // itself on feedback completion), Recruiter Screening's Feedback tab renders
    // feedback-execution-screen directly, so this controller has to reload its own
    // jobMatchInfo/tabs here to pick up a newly-allowed MOVE_FORWARD action.
    feedbackCompleteCallback() {
        this.completeFeedbackCallback.emit();
        this._getData();
    }

    moveToInterviewCallback() {
        this._getData();
    }

    _checkIfContactDetailsMissing() {
        const jobMatchInfo = _.cloneDeep(this.jobMatchInfo);
        jobMatchInfo.candidateAdditionalDetails.workLocations = this.jobMatchInfo.workLocations;
        if (!this.sharedService.isContactDetailsAvailable(jobMatchInfo, 'candidateJobMatchCard') || !this.sharedService.isCandidateAdditionalDetailsAvailable(jobMatchInfo)) {
            this.isCandidateContactDetailsMissing = true;
        } else {
            this.isCandidateContactDetailsMissing = false;
        }
    }

    ngOnDestroy() {
        if (this.refreshBookletSubscription) {
            this.refreshBookletSubscription.unsubscribe();
        }
    }
}
